import { render } from "./App.vue?vue&type=template&id=b390eb7e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b390eb7e&lang=css"

import exportComponent from "/Users/enrico/Projects/perlamare/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__